<template>
  <v-row justify="center">
    <v-col lg="6" md="5" class="pb-0 hidden-sm-and-down">
      <v-img class="sticky-image" height="100vh" :src="createAccountImage" />
    </v-col>
    <v-col v-show="page === 1" class="member-register-renew" lg="6" md="6" sm="10">
      <h2 class="register-title">Membership Renewal</h2>
      <div class="register-description">
        If you are renewing, please review your information for accuracy. If you need to make changes, check the box below indicating "I need to make updates to my information". Submitted changes will be reviewed and may take 24 hours to appear on your account.
      </div>
      <MemberForm isRenewal />
      <div class="footer-container">
        <v-img height="2rem" contain :src="logoImage" />
        <footer-text />
      </div>
    </v-col>
    <AussieTimeRegistration v-show="page === 2" />
    <SummaryPaymentInformation v-show="page === 3" />
  </v-row>
</template>
  
<script lang="ts">
import Vue from 'vue';

import MemberForm from './Steps/MemberForm.vue';
import AussieTimeRegistration from './Steps/AussieTimeRegistrationRenewal.vue';
import SummaryPaymentInformation from './Steps/SummaryPaymentInformation.vue';
import FooterText from '@/components/common/FooterText.vue';

const logoImage = require('@/assets/logo.svg');
const createAccountImage = require('@/assets/create-account.png');

export default Vue.extend({
  components: { FooterText, MemberForm, AussieTimeRegistration, SummaryPaymentInformation },
  name: 'MemberRenewal',
  data: function () {
    return {
      logoImage,
      createAccountImage
    };
  },
  computed: {
    page(): number {
      return this.$store.state.registerRenewMembershipInfo.page;
    },
  }
});
</script>